import React from 'react';

const projects = [
  { title: 'Banking Portal', client: 'Merrill Lynch', category: 'Web Development', icon: '🏦', desc: 'Enterprise banking portal with real-time data and secure transactions.' },
  { title: 'Healthcare Management', client: 'MetLife', category: 'Software Development', icon: '🏥', desc: 'Comprehensive healthcare management system with EMR integration.' },
  { title: 'E-Commerce Platform', client: 'Retail Client', category: 'Web Services', icon: '🛒', desc: 'Full-featured e-commerce platform with inventory and payment systems.' },
  { title: 'Mobile Banking App', client: 'JPMorgan Chase', category: 'Mobile Development', icon: '📱', desc: 'Secure mobile banking application for iOS and Android.' },
  { title: 'SEO Campaign & Digital Marketing', client: 'PepsiCo', category: 'Digital Marketing', icon: '📈', desc: 'Nationwide SEO and digital marketing campaign with 300% ROI.' },
  { title: 'Government Portal', client: 'Federal Agency', category: 'Government', icon: '🏛️', desc: 'Secure citizen services portal with FISMA compliance.' },
  { title: 'Telecom CRM', client: 'Verizon', category: 'Software Development', icon: '📡', desc: 'Custom CRM system for telecom customer management.' },
  { title: 'AI Analytics Dashboard', client: 'NYSE', category: 'AI Services', icon: '🧠', desc: 'AI-powered analytics dashboard for real-time market insights.' },
];

const webDesignProjects = [
  { title: 'Tomedes', client: 'Tomedes', category: 'Language Translation Services', url: 'https://www.tomedes.com', desc: 'Professional language translation and localization services website.' },
];

const Portfolio = () => (
  <>
    <section className="py-5 text-white text-center" style={{ background: 'linear-gradient(135deg, #002868, #1a56db)' }}>
      <div className="container py-4">
        <h1 className="fw-bold">Our Portfolio</h1>
        <p className="lead" style={{ color: '#cbd5e1' }}>Projects we're proud of</p>
      </div>
    </section>

    <section className="py-5 bg-light">
      <div className="container py-4">
        <div className="row g-4">
          {projects.map((p, i) => (
            <div key={i} className="col-12 col-sm-6 col-lg-3">
              <div className="card border-0 shadow-sm h-100 p-3">
                <div style={{ fontSize: 40 }} className="mb-3">{p.icon}</div>
                <span className="badge bg-primary bg-opacity-10 text-primary mb-2" style={{ fontSize: 11 }}>{p.category}</span>
                <h6 className="fw-bold">{p.title}</h6>
                <p className="text-muted small">{p.desc}</p>
                <div className="mt-auto small text-muted fw-semibold">Client: {p.client}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* Web Design and Development */}
    <section className="py-5 bg-white">
      <div className="container py-4">
        <div className="mb-5">
          <span className="badge bg-primary bg-opacity-10 text-primary px-3 py-2 mb-2">WEB DESIGN & DEVELOPMENT</span>
          <h2 className="fw-bold">Web Design and Development</h2>
          <p className="text-muted">A showcase of websites we have designed and developed for our clients.</p>
        </div>
        <div className="row g-4">
          {webDesignProjects.map((p, i) => (
            <div key={i} className="col-12 col-sm-6 col-lg-4">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body p-4">
                  <div className="d-flex align-items-center gap-3 mb-3">
                    <div className="rounded-3 d-flex align-items-center justify-content-center" style={{ width: 48, height: 48, background: '#dbeafe', fontSize: 24 }}>🌐</div>
                    <div>
                      <h6 className="fw-bold mb-0">{p.title}</h6>
                      <span className="badge bg-success bg-opacity-10 text-success" style={{ fontSize: 10 }}>{p.category}</span>
                    </div>
                  </div>
                  <p className="text-muted small mb-3">{p.desc}</p>

                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  </>
);

export default Portfolio;
